import(/* webpackMode: "eager" */ "/home/site/web/sapient.pro/private/sapientpro-frontend/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/site/web/sapient.pro/private/sapientpro-frontend/src/components/Breadcrumbs/Breadcrumbs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/site/web/sapient.pro/private/sapientpro-frontend/src/components/ContactModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/site/web/sapient.pro/private/sapientpro-frontend/src/components/GradientCircles/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/site/web/sapient.pro/private/sapientpro-frontend/src/page-components/Blog/ArticlesList/ArticlesList.tsx");
;
import(/* webpackMode: "eager" */ "/home/site/web/sapient.pro/private/sapientpro-frontend/src/page-components/Blog/Category/Category.module.scss");
